import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mysales',
  templateUrl: './mysales.component.html',
  styleUrls: ['./mysales.component.scss']
})
export class MysalesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
